import { post, postFile } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main";

const state = {
  items: [],
  isLoadingData: true,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  isShowResultDialog: false,
  resultMsg: "",
  isSuccess: false,
  brands: [],
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
    state.isLoadingData = false;
  },
  SET_IS_BTN_LOADING(state, isBtnLoading) {
    state.isBtnLoading = isBtnLoading;
  },

  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((item) => {
      return item.br_id !== id;
    });
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_DELETE_SUCCESS(state, value) {
    state.isShowResultDialog = value.state;
    state.resultMsg = value.msg;
    state.isSuccess = value.isSuccess;
  },
  SET_BRANDS(state, brands) {
    state.brands = brands;
  },
};

const actions = {
  async getBrands({ commit }) {
    try {
      post("brand/get-brands", {})
        .then((response) => {
          commit("SET_BRANDS", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  },
  async getItems({ commit }) {
    try {
      post(
        "brand/index",
        {},
        {
          id: 5,
          action: "view",
        }
      )
        .then((response) => {
          commit("SET_ITEMS", response.data);
          commit("SET_IS_BTN_LOADING", false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  },
  async addNewItem({ commit }, payload) {
    const formData = new FormData();
    formData.append("br_name", payload.br_name);
    if (payload.file) {
      formData.append("file", payload.file);
    }

    return postFile(
      "brand/store",
      formData,
      {
        id: 5,
        action: "add",
      }
    )
      .then((response) => {
        this.dispatch("brand/getItems");

        const t = i18n.global.t;
        toast("success", t("added_successfully"));
        return response;
      })
      .catch((error) => {
        commit("SET_IS_BTN_LOADING", false);

        const t = i18n.global.t;
        if (error.response.status == 408) {
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }

        toast("error", t("something_wrong"));
        console.log(error);
        return error;
      });
  },
  async deleteItem({ commit }, id) {
    post(
      "brand/delete/" + id,
      {},
      {
        id: 5,
        action: "delete",
      }
    )
      .then((response) => {
        this.dispatch("brand/getItems");

        const t = i18n.global.t;
        toast("success", t("deleted_successfully"));
        return response;
      })
      .catch((error) => {
        const t = i18n.global.t;
        this.dispatch("brand/getItems");
        commit("SET_IS_BTN_LOADING", false);
        if (error.response.status == 408) {
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return;
        }

        if (
          error.response.data.message.includes(
            "Cannot delete or update a parent row"
          )
        ) {
          commit("SET_DELETE_SUCCESS", {
            state: true,
            msg: t(
              "you_can_not_delete_this_item_because_there_are_related_items"
            ),
            isSuccess: false,
          });
        } else {
          commit("SET_DELETE_SUCCESS", {
            state: true,
            msg: t("something_wrong"),
            isSuccess: false,
          });
        }
      });
  },
  async editItem({ commit }, payload) {
    const formData = new FormData();
    formData.append("br_name", payload.br_name);
    if (payload.file) {
      formData.append("file", payload.file);
    }

    return postFile(
      "brand/edit/" + payload.br_id,
      formData,
      {
        id: 5,
        action: "edit",
      }
    )
      .then((response) => {
        this.dispatch("brand/getItems");

        const t = i18n.global.t;
        toast("success", t("edited_successfully"));
        return response;
      })
      .catch((error) => {
        commit("SET_IS_BTN_EDIT_LOADING", false);

        const t = i18n.global.t;
        if (error.response.status == 408) {
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }
        toast("error", t("something_wrong"));
        console.log(error);
        return error;
      });
  },
};

const getters = {
  filterItems(state) {
    function deepSearch(obj, searchValue) {
      for (const key in obj) {
        const value = obj[key];

        if (value !== null && typeof value === "object") {
          if (deepSearch(value, searchValue)) {
            return true;
          }
        } else {
          if (
            value != null &&
            value.toString().toLowerCase().includes(searchValue.toLowerCase())
          ) {
            return true;
          }
        }
      }
      return false;
    }

    return state.items.filter((item) => {
      return deepSearch(item, state.search.toLowerCase());
    });
  },
  getResultDialog: (state) => state.isShowResultDialog,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
